// extracted by mini-css-extract-plugin
export default {"root":"home-page_root__fYtIt","cards":"home-page_cards__HOgFC"};